module.exports = __webpack_public_path__ + "static/media/Passing the Faith.f78ce17b.jpg";